import { IFirebaseShoppingCartProducts } from '@monofront/types';

const isEmpty = (obj) => Object.keys(obj).length === 0;

const formatToOldKey = (shoppingCart) =>
  Object.keys(shoppingCart).reduce(
    (acc, key) => ({
      ...acc,
      [key.split('|')[0]]: shoppingCart[key],
    }),
    {},
  );

// Info: firebase merges only keys. it does not increment quantities.
// So need to merge manually with good incrementation of quantities
export const mergeShoppingCarts = (
  firstShoppingCart: IFirebaseShoppingCartProducts,
  secondShoppingCart: IFirebaseShoppingCartProducts,
) => {
  if (!firstShoppingCart || isEmpty(firstShoppingCart)) {
    return secondShoppingCart;
  }

  if (!secondShoppingCart || isEmpty(secondShoppingCart)) {
    return firstShoppingCart;
  }

  const isFirstOld = !Object.keys(firstShoppingCart).some((key) =>
    key.includes('|'),
  );
  const isSecondOld = !Object.keys(secondShoppingCart)?.some((key) =>
    key.includes('|'),
  );

  const formattedFirstShoppingCart =
    isSecondOld && !isFirstOld
      ? formatToOldKey(firstShoppingCart)
      : firstShoppingCart;

  const formattedSecondShoppingCart =
    isFirstOld && !isSecondOld
      ? formatToOldKey(secondShoppingCart)
      : secondShoppingCart;

  const mergedShoppingCartsWithoutQuantitiesMerged = {
    ...formattedFirstShoppingCart,
    ...formattedSecondShoppingCart,
  };

  return Object.keys(mergedShoppingCartsWithoutQuantitiesMerged).reduce(
    (accumulator, currentProductId) => {
      let currentProductTotalQuantity =
        mergedShoppingCartsWithoutQuantitiesMerged[currentProductId];

      if (
        formattedFirstShoppingCart[currentProductId] &&
        formattedSecondShoppingCart[currentProductId]
      ) {
        currentProductTotalQuantity =
          formattedFirstShoppingCart[currentProductId] +
          formattedSecondShoppingCart[currentProductId];
      }

      return {
        ...accumulator,
        [currentProductId]: currentProductTotalQuantity,
      };
    },
    {},
  );
};
